import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

/**
 * Injectable
 */
@Injectable({
	providedIn: 'root'
})
export class UnitsDataService {

	/** apiUnits */
	private apiUnits = "api/SIUnits";

	/**
	 * Default Constructor
	 * @param http Imports the 'HttpClient' Object for internet requests
	 * @param globalFunctions Global Functions
	 * @param siteSubscriptions site Subscriptions
	 */
	constructor(
		private http: HttpClient,
		public globalFunctions: GlobalFunctions,
		public siteSubscriptions: siteSubscriptions
	) { }

	/**
	 * Get the SI Units
	 * @returns SIUnits
	 */
	getSIUnits$(): Observable<any> {
		let url = `${environment.apiUrl}/${this.apiUnits}`;
		return this.globalFunctions.fetchAPI(this.http, url, "GET", {});
	}

}
